// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1qFmX","fileBtn":"File_fileBtn__3F4Q6","closeBtn":"File_closeBtn__pOgiU","fileSelected":"File_fileSelected__3ixOR","disabled":"File_disabled__2q9SE"};